import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';

const Styling = styled.div`
  .cls-1 {
    fill: ${({ color }) => color};
  }
`;

const Excel = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <Styling color={iconColor}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 21.09999 22.6"
      >
        <title>{iconTitle}</title>
        <g id="Layer_2" data-name="Layer 2">
          <g id="pdf">
            <g id="Layer_2-2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1-2">
                <g id="Layer_1-3" data-name="Layer 1-3">
                  <g id="Layer_2-2-2" data-name="Layer 2-2">
                    <g id="Layer_1-2-2" data-name="Layer 1-2-2">
                      <g id="Layer_3" data-name="Layer 3">
                        <polygon
                          className="cls-1"
                          points="16 19.2 16 21.3 1.3 21.3 1.3 1.3 12.7 1.3 12.7 4.6 16 4.6 16 8.5 17.3 8.5 17.3 3.9 13.4 0 0 0 0 22.6 17.3 22.6 17.3 19.2 16 19.2"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <path
              className="cls-1"
              d="M3.2,9.3v9H21.1v-9Zm6.16639,7.42969-.4878-.97559c-.1997-.376-.32763-.65527-.47949-.96777H8.383c-.11182.3125-.24805.5918-.416.96777l-.44775.97559H6.12813l1.55908-2.72656L6.18428,11.34H7.5832l.47168.9834c.16016.32812.27979.59179.40772.89551h.01611c.12793-.34375.23193-.583.36768-.89551l.45605-.9834h1.39111l-1.519,2.63086,1.59912,2.75879Zm5.43164,0H11.43184V11.34h1.22265v4.36621h2.14356Zm2.041.08008a3.524,3.524,0,0,1-1.52734-.32813l.24805-1.00684a3.11725,3.11725,0,0,0,1.35058.335c.55957,0,.85547-.23145.85547-.583,0-.33594-.25586-.52832-.90332-.75977-.89551-.3125-1.47949-.80761-1.47949-1.59179,0-.91895.76758-1.62256,2.03906-1.62256a3.28971,3.28971,0,0,1,1.375.272l-.27148.9834a2.55307,2.55307,0,0,0-1.127-.25586c-.52832,0-.78418.23926-.78418.51953,0,.34375.30371.49609,1,.75977.95118.35156,1.39942.84765,1.39942,1.60742C19.01387,16.04219,18.31758,16.80977,16.83906,16.80977Z"
            />
          </g>
        </g>
      </svg>
    </Styling>
  );
};

Excel.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Excel.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Excel);
